import React from 'react';
import { SubappConfig } from './generateAppConfig';

export default function createExternalLink(
  label: string,
  subpath: string,
  url: string,
  isLive: boolean = true,
  openInNewTab: boolean = false
): SubappConfig {
  return {
    path: subpath,
    isLive,
    navItemConfig: { label },
    appConfig: {
      Component: () => {
        if (openInNewTab) {
          window.open(url, '_blank', 'noopener,noreferrer');
        } else {
          window.location.href = url;
        }
        return <></>;
      },
    },
  };
}
